import { render, staticRenderFns } from "./DayOff.vue?vue&type=template&id=1800f451&scoped=true"
import script from "./DayOff.vue?vue&type=script&lang=js"
export * from "./DayOff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1800f451",
  null
  
)

export default component.exports